import React, { useEffect } from 'react';
import { initializeUserAuth} from '../../common/auth/index';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import '@nike/ruxac/fonts';
import '@nike/ruxac/styles';


import {
   
    LoadingScreen
} from '@nike/ruxac';
import { GenericError, Login } from '../../common/auth/utilities';

import config from '../../config/oAuthConfig'

import AccessDenied from '../../common/auth/utilities/errors/NotAuthorized'

import DLAC from '../dlacomponent'
export  const App = ({ children }) => {
    
    const dispatch = useDispatch();
   
  
     // Authenticate User
     useEffect(() => {
        dispatch({ type: initializeUserAuth.type });
        // eslint-disable-next-line
    }, []);

    const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
    const loginFinished = useSelector(
        (state) => state.auth.hasAuthCheckFinished
    );
    
    const loginError = useSelector((state) => {

      return  state.auth.loginError;
    }
      );
    
    const previousLocation = useSelector(
        (state) => state.auth.previousLocation
    );

    const history = useHistory();

    useEffect(() => {
        if (isLoggedIn) {
            history.push(previousLocation || config.pathName);
        }
        // eslint-disable-next-line
    }, [isLoggedIn, previousLocation]);


     if(window.location.search && window.location.search.indexOf("error=access_denied")>=0){
    
        return <AccessDenied />;

    }

    if (!loginFinished) return  <LoadingScreen
    isLoading={true}
    loadingMessage='Loading...' />
    
    
    if (!isLoggedIn) return <Login />;
    if (loginError) return <GenericError error={loginError} />
    return (
        <DLAC />
    );
};


export default App


